import React from "react";

import clsx from "clsx";

import styles from "./ErrorContent.module.scss";

interface IErrorContent {
  text?: string;
  className?: string;
}

export const ErrorContent: React.FC<IErrorContent> = ({ children, text, className }) => {
  return <div className={clsx(styles.base, className)}>{text ? <p>{text}</p> : children}</div>;
};
